module.exports = __webpack_public_path__ + "img/vegan.01827cf7.jpeg";